module.exports = __webpack_public_path__ + "img/light.9f28c7da.svg";